export { handleDOMGoogleTranslateIssues } from './google-translate-issue-workaround';
